<div [ngStyle]="{ width: width, height: height, borderRadius: borderRadius }" class="relative-wrapper">
  <img [src]="src" alt="image" class="absolute-img"/>
  <div [ngStyle]="{ border: border }" class="absolute-bordered-div"></div>
</div>
